<template>
  <div dir="rtl" class="is-flex">
    <input
      v-if="show_time"
      dir="ltr"
      @input="changed"
      v-model="time_string"
      placeholder="20:00"
      type="time"
    />
    <div v-if="show_time" class="horizontal_space"></div>
    <input dir="ltr" @input="changed" v-model="date_string" placeholder="20/03/2017" type="date" />
  </div>
</template>
<script>
import TimeHelper from '@/custom/classes/time_helper.js'
export default {
  name: 'date-time',
  props: {
    date: {
      type: String,
      default: undefined
    },
    show_time: {
      type: Boolean,
      default: true
    }
  },
  data () {
    let time_helper = new TimeHelper()
    return {
      time_helper: time_helper,
      date_string: '',
      time_string: ''
    }
  },
  mounted () {
    this.init()
  },
  watch: {
    date () {
      this.init()
    }
  },
  methods: {
    init () {
      if (new Date(this.date).getFullYear() < 1000) {
        return
      }
      this.date_string = this.date == undefined ? '' : this.time_helper.getDateInput(this.date)
      this.time_string = this.date == undefined ? '' : this.time_helper.getTimeInput(this.date)
    },
    changed () {
      this.$emit('input', this.getDateString())
    },
    getDateString () {
      let date = this.time_helper.setDate(this.date_string)
      if (!date) {
        return null
      }
      if (this.time_string == 'NaN:NaN') {
        this.time_string = ''
      }
      date = this.time_helper.setTime(date, this.time_string)
      return date.toUTCString()
    }
  }
}
</script>
